// extracted by mini-css-extract-plugin
module.exports = {"dynamicContent":"az_jAc","title":"az_kAc","label":"az_lAc"};